import { TransactionData, TransactionStatus } from '@/features/Transactions/transactions.types'
import { DateTime } from 'luxon'

export function sortByKey<T>(array: T[], key: string) {
  return array.sort((a, b) => {
    if (a[key] === b[key]) {
      return 0
    } if (a[key] === true) {
      return -1
    }
    return 1
  })
}

export function groupByCreatedAt(transactions: TransactionData[]) {
  const groupedTransactions = Object.create(null)
  for (let i = 0; i < transactions.length; i++) {
    const transaction = transactions[i]
    const createdAt = DateTime.fromISO(transaction.createdAt).toISODate() // Local calendar day, not the UTC day

    if (!groupedTransactions[createdAt]) {
      groupedTransactions[createdAt] = []
    }

    groupedTransactions[createdAt].push(transaction)
  }

  return groupedTransactions
}

export function groupByCreatedAtAndStatus(transactions: TransactionData[]) {
  const groupedTransactions = Object.create(null)

  const inProgressTransactions = transactions?.filter((transaction) => transaction.status === TransactionStatus.IN_PROGRESS)
  // Separate 'IN_PROGRESS' transactions
  if (inProgressTransactions.length > 0) {
    groupedTransactions.IN_PROGRESS = inProgressTransactions
  }

  const canceledTransactions = transactions?.filter((transaction) => transaction.status === TransactionStatus.ERROR_SEND)
  if (canceledTransactions.length > 0) {
    groupedTransactions.IN_PROGRESS = [...inProgressTransactions, ...canceledTransactions]
  }

  // Group remaining transactions by date
  for (let i = 0; i < transactions.length; i++) {
    const transaction = transactions[i]

    // Skip 'IN_PROGRESS' transactions since they are already grouped
    if (transaction.status === TransactionStatus.IN_PROGRESS || transaction.status === TransactionStatus.ERROR_SEND) continue

    const createdAt = DateTime.fromISO(transaction.createdAt).toISODate() // Local calendar day, not the UTC day
    if (!groupedTransactions[createdAt]) {
      groupedTransactions[createdAt] = []
    }

    groupedTransactions[createdAt].push(transaction)
  }

  return groupedTransactions
}
